import React from 'react'; // eslint-disable-line @typescript-eslint/no-unused-vars

import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';

import Pin from '../../@common/Pin';
import useStore from 'store';
const useStyles = makeStyles(theme => ({
  listItem: {
    minHeight: 48
  },
  listTextItem: {
    flex: 'unset',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 190
  },
  listItemContainer: {
    flexGrow: 1,
    display: 'flex'
  },
  iconButton: {
    '&:hover': {
      background: 'unset'
    },
    color: theme.palette.secondary.main,
    marginTop: -(theme.spacing(1) / 2),
    marginLeft: theme.spacing(1) / 2
  },
  visibilityOpen: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short
    })
  },
  visibilityClose: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short
    })
  }
}));

export interface PINNavigatonItemProps {
  open: boolean;
}

const PINNavigatonItem = ({ open }: PINNavigatonItemProps): React.ReactElement => {
  const classes = useStyles();
  const [
    {
      user: { me }
    }
  ] = useStore();

  return (
    <ListItem component="div" className={classes.listItem}>
      {open && <Pin pin={me?.pin || ''} />}
    </ListItem>
  );
};

export default PINNavigatonItem;
